import { create } from "zustand";
export const useAdminAccess = create(() => ({ needsConfirmation: true }));

export function requestAdminStepUp() {
  useAdminAccess.setState({ needsConfirmation: true });
}

export function isAdminPath(path: string) {
  return path === "/admin" || path.startsWith("/admin/");
}
